const FIELD_TYPES = [
  { id: 'ft1', label: 'Text Input', icon: 'type', desc: 'Single-line text' },
  { id: 'ft2', label: 'Text Area', icon: 'alignLeft', desc: 'Multi-line text' },
  { id: 'ft3', label: 'Date Picker', icon: 'calendar', desc: 'Date or date range' },
  { id: 'ft4', label: 'Dropdown', icon: 'chevronDown', desc: 'Select from list' },
  { id: 'ft5', label: 'Checkbox', icon: 'checkSquare', desc: 'Yes / No toggle' },
  { id: 'ft6', label: 'Multi-select', icon: 'list', desc: 'Multiple choices' },
  { id: 'ft7', label: 'Number', icon: 'hash', desc: 'Numeric value' },
  { id: 'ft8', label: 'Signature', icon: 'edit', desc: 'E-signature pad' },
  { id: 'ft9', label: 'Tooth Selector', icon: 'grid', desc: 'Dental chart picker' },
  { id: 'ft10', label: 'File Upload', icon: 'upload', desc: 'Document or image' }
]

const FORM_LIBRARY = [
  { id: 'f1', name: 'New Patient Intake', category: 'Intake', fields: 22, status: 'Active', lastEdited: 'Mar 12, 2026', submissions: 148, createdBy: 'Dr. Kvaratskhelia' },
  { id: 'f2', name: 'Medical History Update', category: 'History', fields: 31, status: 'Active', lastEdited: 'Feb 28, 2026', submissions: 203, createdBy: 'Admin' },
  { id: 'f3', name: 'Pain Assessment Form', category: 'Clinical', fields: 9, status: 'Active', lastEdited: 'Mar 1, 2026', submissions: 89, createdBy: 'Dr. Lomidze' },
  { id: 'f4', name: 'Post-Op Instructions', category: 'Clinical', fields: 6, status: 'Draft', lastEdited: 'Mar 17, 2026', submissions: 0, createdBy: 'Dr. Beridze' },
  { id: 'f5', name: 'Perio Screening Chart', category: 'Clinical', fields: 14, status: 'Active', lastEdited: 'Mar 5, 2026', submissions: 62, createdBy: 'Dr. Kvaratskhelia' },
  { id: 'f6', name: 'Treatment Satisfaction Survey', category: 'Feedback', fields: 8, status: 'Active', lastEdited: 'Mar 10, 2026', submissions: 97, createdBy: 'Admin' }
]

const ACTIVE_FIELDS = [
  { id: 'af1', label: 'Patient Full Name', type: 'Text Input', required: true },
  { id: 'af2', label: 'Date of Birth', type: 'Date Picker', required: true },
  { id: 'af3', label: 'Chief Complaint', type: 'Text Area', required: true },
  { id: 'af4', label: 'Pain Level (1–10)', type: 'Number', required: false },
  { id: 'af5', label: 'Affected Tooth', type: 'Tooth Selector', required: false },
  { id: 'af6', label: 'Duration of Symptoms', type: 'Dropdown', required: false },
  { id: 'af7', label: 'Previous Treatment', type: 'Checkbox', required: false },
  { id: 'af8', label: 'Additional Notes', type: 'Text Area', required: false }
]

export const formBuilder = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',

  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'templates', fbView: 'library' })) } return false } })() },

  NavSidebar: {},

  MainContent: {
    flow: 'y', flex: '1', overflow: 'auto',
    TopBar: {},

    ContentArea: {
      flow: 'y', gap: 'B', padding: 'B', flex: '1',
      '@mobileL': { padding: 'A' },

      PageHeader: {
        flow: 'x', align: 'center space-between', flexWrap: 'wrap', gap: 'Z',
        HeaderLeft: {
          flow: 'y', gap: 'X',
          PageTitle: { tag: 'h1', text: 'Form Builder', fontSize: 'C', fontWeight: '700', color: 'inkText', letterSpacing: '-0.02em' },
          PageSubtitle: { text: 'Design custom intake and clinical forms for your patients', fontSize: 'Z', color: 'inkMuted' }
        },
        NewFormBtn: {
          tag: 'button', text: '+ New Form',
          fontSize: 'Z', fontWeight: '600', padding: 'Z A', round: 'A',
          background: 'teal', color: 'ink', border: 'none', cursor: 'pointer',
          onClick: (e, el, s) => s.root.update({ fbView: 'builder' })
        }
      },

      ViewTabs: {
        flow: 'x', gap: 'Z', borderBottom: '1px solid inkBorder', paddingBottom: 'Y',
        LibraryTab: {
          text: 'Form Library',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
          color: (el, s) => (s.root.fbView || 'library') === 'library' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => (s.root.fbView || 'library') === 'library' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ fbView: 'library' })
        },
        BuilderTab: {
          text: 'Builder',
          fontSize: 'Z', fontWeight: '600', padding: 'Y Z', cursor: 'pointer',
          color: (el, s) => s.root.fbView === 'builder' ? 'teal' : 'inkMuted',
          borderBottom: (el, s) => s.root.fbView === 'builder' ? '2px solid teal' : '2px solid transparent',
          onClick: (e, el, s) => s.root.update({ fbView: 'builder' })
        }
      },

      // ─── LIBRARY VIEW ──────────────────────────────
      LibraryView: {
        show: (el, s) => (s.root.fbView || 'library') === 'library',
        flow: 'y', gap: 'A',

        LibraryStats: {
          flow: 'x', gap: 'A', flexWrap: 'wrap',
          StatActive: {
            flow: 'y', gap: 'X', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'F',
            SVal: { text: '5', fontSize: 'C', fontWeight: '700', color: 'teal', letterSpacing: '-0.02em' },
            SLbl: { text: 'Active Forms', fontSize: 'Y', color: 'inkMuted' }
          },
          StatDraft: {
            flow: 'y', gap: 'X', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'F',
            SVal: { text: '1', fontSize: 'C', fontWeight: '700', color: 'amber', letterSpacing: '-0.02em' },
            SLbl: { text: 'Draft Forms', fontSize: 'Y', color: 'inkMuted' }
          },
          StatSubs: {
            flow: 'y', gap: 'X', padding: 'A', round: 'A',
            background: 'inkMid', border: '1px solid inkBorder', flex: '1', minWidth: 'F',
            SVal: { text: '599', fontSize: 'C', fontWeight: '700', color: 'green', letterSpacing: '-0.02em' },
            SLbl: { text: 'Total Submissions', fontSize: 'Y', color: 'inkMuted' }
          }
        },

        FormList: {
          flow: 'y', gap: 'Z',
          children: FORM_LIBRARY,
          childrenAs: 'state',
          childExtends: {
            flow: 'x', gap: 'A', align: 'center space-between',
            padding: 'A', round: 'A', background: 'inkMid',
            border: '1px solid inkBorder', flexWrap: 'wrap',

            FormInfo: {
              flow: 'x', gap: 'A', align: 'center flex-start', flex: '1', minWidth: '200px',
              FormIconWrap: {
                width: 'D', height: 'D', round: 'Y', flexShrink: '0',
                flow: 'x', align: 'center center', background: 'teal.10',
                FIcon: { extends: 'Icon', icon: 'fileText', width: 'B', height: 'B', color: 'teal' }
              },
              FormMeta: {
                flow: 'y', gap: 'X',
                FormName: { text: (el, s) => s.name, fontSize: 'Z', fontWeight: '700', color: 'inkText' },
                FormMetaRow: {
                  flow: 'x', gap: 'Z', flexWrap: 'wrap',
                  FormCat: { tag: 'span', text: (el, s) => s.category, fontSize: 'Y', color: 'inkMuted' },
                  MetaDot: { tag: 'span', text: '·', fontSize: 'Y', color: 'inkMuted' },
                  FormFields: { text: (el, s) => (s.fields || 0) + ' fields', fontSize: 'Y', color: 'inkMuted' },
                  MetaDot2: { tag: 'span', text: '·', fontSize: 'Y', color: 'inkMuted' },
                  FormSubs: { text: (el, s) => (s.submissions || 0) + ' submissions', fontSize: 'Y', color: 'inkMuted' }
                }
              }
            },

            FormRight: {
              flow: 'x', gap: 'A', align: 'center center',
              StatusBadge: {
                tag: 'span',
                text: (el, s) => s.status,
                fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'B',
                background: (el, s) => s.status === 'Active' ? 'green.12' : 'amber.12',
                color: (el, s) => s.status === 'Active' ? 'green' : 'amber'
              },
              FormActions: {
                flow: 'x', gap: 'Y',
                PreviewBtn: { tag: 'button', text: 'Preview', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'Y', background: 'inkSurface', color: 'inkMuted', border: '1px solid inkBorder', cursor: 'pointer' },
                EditBtn: { tag: 'button', text: 'Edit', fontSize: 'Y', fontWeight: '600', padding: 'X Z', round: 'Y', background: 'teal', color: 'ink', border: 'none', cursor: 'pointer', onClick: (e, el, s) => s.root.update({ fbView: 'builder' }) }
              }
            }
          }
        }
      },

      // ─── BUILDER VIEW ──────────────────────────────
      BuilderView: {
        show: (el, s) => s.root.fbView === 'builder',
        flow: 'x', gap: 'A', align: 'flex-start',
        '@mobileL': { flow: 'y' },

        FieldPalette: {
          flow: 'y', gap: 'Z', width: 'I', flexShrink: '0',
          '@mobileL': { width: '100%' },

          PaletteHeader: {
            flow: 'y', gap: 'X', marginBottom: 'Y',
            PaletteTitle: { text: 'Field Types', fontSize: 'Z', fontWeight: '700', color: 'inkText' },
            PaletteSub: { text: 'Click to add to form', fontSize: 'Y', color: 'inkMuted' }
          },

          FieldList: {
            flow: 'y', gap: 'Y',
            children: FIELD_TYPES,
            childrenAs: 'state',
            childExtends: {
              flow: 'x', gap: 'Z', align: 'center flex-start',
              padding: 'Y Z', round: 'Y',
              background: 'inkMid', border: '1px solid inkBorder', cursor: 'pointer',
              FieldIcon: { extends: 'Icon', icon: (el, s) => s.icon || 'type', width: 'B', height: 'B', color: 'teal', flexShrink: '0' },
              FieldInfo: {
                flow: 'y', gap: 'X',
                FieldLabel: { text: (el, s) => s.label, fontSize: 'Y', fontWeight: '600', color: 'inkText' },
                FieldDesc: { text: (el, s) => s.desc, fontSize: 'X', color: 'inkMuted' }
              }
            }
          }
        },

        BuilderCanvas: {
          flow: 'y', gap: 'Z', flex: '1',

          CanvasHeader: {
            flow: 'x', align: 'center space-between', padding: 'Z A',
            background: 'inkMid', round: 'A', border: '1px solid inkBorder', marginBottom: 'Y',
            CanvasLeft: {
              flow: 'y', gap: 'X',
              FormNameInput: { tag: 'input', type: 'text', value: 'New Patient Intake', fontSize: 'Z', fontWeight: '700', color: 'inkText', background: 'transparent', border: 'none', outline: 'none', padding: '0' },
              FormCategory: { tag: 'span', text: 'Category: Intake', fontSize: 'Y', color: 'inkMuted' }
            },
            CanvasActions: {
              flow: 'x', gap: 'Z',
              SaveDraftBtn: { tag: 'button', text: 'Save Draft', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'inkSurface', color: 'inkText', border: '1px solid inkBorder', cursor: 'pointer' },
              PublishBtn: { tag: 'button', text: 'Publish Form', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'teal', color: 'ink', border: 'none', cursor: 'pointer' }
            }
          },

          CanvasFields: {
            flow: 'y', gap: 'Z',
            children: ACTIVE_FIELDS,
            childrenAs: 'state',
            childExtends: {
              flow: 'x', gap: 'Z', align: 'center flex-start',
              padding: 'Z A', round: 'Y',
              background: 'inkMid', border: '1px solid inkBorder',

              DragHandle: { tag: 'span', text: '⠿', fontSize: 'A', color: 'inkMuted', cursor: 'grab', flexShrink: '0' },

              FieldBody: {
                flow: 'y', gap: 'X', flex: '1',
                FieldRow: {
                  flow: 'x', gap: 'Z', align: 'center flex-start',
                  FieldLabelText: { text: (el, s) => s.label, fontSize: 'Z', fontWeight: '600', color: 'inkText' },
                  RequiredDot: { tag: 'span', text: (el, s) => s.required ? ' *' : '', fontSize: 'Z', color: 'red', fontWeight: '700' }
                },
                FieldTypePill: { tag: 'span', text: (el, s) => s.type, fontSize: 'Y', color: 'inkMuted' }
              },

              FieldActions: {
                flow: 'x', gap: 'Y', flexShrink: '0',
                RequireToggle: {
                  tag: 'span',
                  text: (el, s) => s.required ? 'Required' : 'Optional',
                  fontSize: 'Y', fontWeight: '600', padding: 'X Y', round: 'C',
                  background: (el, s) => s.required ? 'teal.12' : 'inkSurface',
                  color: (el, s) => s.required ? 'teal' : 'inkMuted',
                  cursor: 'pointer'
                },
                DeleteField: { extends: 'Icon', icon: 'trash2', width: 'B', height: 'B', color: 'inkMuted', cursor: 'pointer' }
              }
            }
          },

          AddFieldHint: {
            flow: 'x', gap: 'Z', align: 'center center',
            padding: 'A', round: 'A', border: '1px dashed inkBorder',
            color: 'inkMuted', cursor: 'pointer', marginTop: 'Y',
            AddIcon: { extends: 'Icon', icon: 'plus', width: 'B', height: 'B', color: 'inkMuted' },
            AddText: { text: 'Click a field type on the left to add', fontSize: 'Y', color: 'inkMuted' }
          }
        }
      }
    }
  }
}
